/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDashboardVerificationFromDiscriminatorValue, type DashboardVerification } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/GetVerificationsByFile
 */
export interface GetVerificationsByFileRequestBuilder extends BaseRequestBuilder<GetVerificationsByFileRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DashboardVerification[]>}
     */
     get(requestConfiguration?: RequestConfiguration<GetVerificationsByFileRequestBuilderGetQueryParameters> | undefined) : Promise<DashboardVerification[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetVerificationsByFileRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetVerificationsByFileRequestBuilderGetQueryParameters {
    bookingNumber?: string;
    passengerDataFileId?: number;
}
/**
 * Uri template for the request builder.
 */
export const GetVerificationsByFileRequestBuilderUriTemplate = "{+baseurl}/Dashboard/GetVerificationsByFile?bookingNumber={bookingNumber}&passengerDataFileId={passengerDataFileId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetVerificationsByFileRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetVerificationsByFileRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createDashboardVerificationFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
